import React, { useEffect, useState } from 'react';
import api from '../api';
import './PageTable.css';
function News() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [uploading, setUploading] = useState({});
  const [form, setForm] = useState({ title: '', content: '', thumbnail_url: '', photo_url_2: '', photo_url_3: '', status: 'draft' });
  const fetchNews = async () => {
    setLoading(true);
    try {
      const res = await api.get('/news/admin/all');
      setNews(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchNews();
  }, []);
  const openCreate = () => {
    setForm({ title: '', content: '', thumbnail_url: '', photo_url_2: '', photo_url_3: '', status: 'draft' });
    setModal({});
  };
  const openEdit = (item) => {
    setForm({
      title: item.title,
      content: item.content || '',
      thumbnail_url: item.thumbnail_url || '',
      photo_url_2: item.photo_url_2 || '',
      photo_url_3: item.photo_url_3 || '',
      status: item.status,
    });
    setModal(item);
  };
  const submitForm = async (e) => {
    e.preventDefault();
    try {
      if (modal.id) {
        await api.put(`/news/${modal.id}`, form);
      } else {
        await api.post('/news', form);
      }
      setModal(null);
      await fetchNews();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menyimpan berita');
    }
  };
  const deleteNews = async (id) => {
    if (!window.confirm('Hapus berita ini?')) return;
    try {
      await api.delete(`/news/${id}`);
      await fetchNews();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menghapus berita');
    }
  };

  const handleFileUpload = async (e, fieldName) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading((u) => ({ ...u, [fieldName]: true }));
    try {
      const formData = new FormData();
      formData.append('photo', file);
      const res = await api.post('/admin-upload/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setForm((f) => ({ ...f, [fieldName]: res.data.url }));
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal upload foto');
    } finally {
      setUploading((u) => ({ ...u, [fieldName]: false }));
      e.target.value = '';
    }
  };

  const PhotoField = ({ label, fieldName }) => (
    <>
      <label style={{ display: 'block', fontSize: 12, color: '#888', marginTop: 8 }}>{label}</label>
      <input
        type="url"
        placeholder={`URL gambar ${label.toLowerCase()} (atau upload di bawah)`}
        value={form[fieldName]}
        onChange={(e) => setForm({ ...form, [fieldName]: e.target.value })}
      />
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6 }}>
        <label style={{ display: 'inline-block', fontSize: 13, color: '#C9A66B', border: '1px solid #C9A66B', padding: '6px 14px', borderRadius: 6, cursor: 'pointer' }}>
          {uploading[fieldName] ? 'Mengupload...' : '📁 Upload dari Perangkat'}
          <input type="file" accept="image/jpeg,image/png,image/webp" onChange={(e) => handleFileUpload(e, fieldName)} disabled={uploading[fieldName]} style={{ display: 'none' }} />
        </label>
        {form[fieldName] && (
          <div style={{ width: 36, height: 36, borderRadius: 4, overflow: 'hidden', background: '#303034' }}>
            <img src={form[fieldName]} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
          </div>
        )}
      </div>
    </>
  );

  return (
    <div>
      <div className="page-header-row">
        <h1 className="page-title" style={{ marginBottom: 0 }}>Berita</h1>
        <button className="btn-primary" onClick={openCreate}>+ Tulis Berita</button>
      </div>
      {loading ? (
        <p>Memuat...</p>
      ) : (
        <div className="table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Judul</th>
              <th>Status</th>
              <th>Tanggal</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {news.map((n) => (
              <tr key={n.id}>
                <td>{n.title}</td>
                <td><span className={`status-badge status-${n.status === 'published' ? 'approved' : 'pending'}`}>{n.status}</span></td>
                <td>{new Date(n.created_at).toLocaleDateString('id-ID')}</td>
                <td>
                  <div className="action-buttons">
                    <button className="btn-edit" onClick={() => openEdit(n)}>Edit</button>
                    <button className="btn-delete" onClick={() => deleteNews(n.id)}>Hapus</button>
                  </div>
                </td>
              </tr>
            ))}
            {news.length === 0 && (
              <tr>
                <td colSpan="4" style={{ textAlign: 'center', color: '#888' }}>
                  Belum ada berita
                </td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
      )}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <form className="modal-box" onClick={(e) => e.stopPropagation()} onSubmit={submitForm} style={{ maxHeight: '85vh', overflowY: 'auto' }}>
            <h2>{modal.id ? 'Edit Berita' : 'Tulis Berita Baru'}</h2>
            <input
              type="text"
              placeholder="Judul"
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              required
            />

            <PhotoField label="Foto 1 (utama)" fieldName="thumbnail_url" />
            <PhotoField label="Foto 2 (opsional)" fieldName="photo_url_2" />
            <PhotoField label="Foto 3 (opsional)" fieldName="photo_url_3" />

            <textarea
              placeholder="Isi berita"
              rows={6}
              value={form.content}
              onChange={(e) => setForm({ ...form, content: e.target.value })}
              style={{ marginTop: 12 }}
            />
            <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} style={{ marginTop: 8 }}>
              <option value="draft">Draft</option>
              <option value="published">Published</option>
            </select>
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={() => setModal(null)}>Batal</button>
              <button type="submit" className="btn-primary">Simpan</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
export default News;
